import wordpressService from '../../../app.service'

const getHomepage = ({ commit }) => {
  return wordpressService.getHomepage().then((page) => {
    page = (JSON.parse(page))
    commit('HOMEPAGE_UPDATED', page)
    commit('SET_PAGE_TITLE', 'Anna Miller Architekci – biuro projektowe')
    commit('SET_PAGE_DESC', 'Pracownia architektoniczna, której kluczowym profilem działalności jest kreowanie wnętrz komercyjnych. Tworzymy wyjątkowe projekty lokali handlowo-usługowych, sklepów, biur.')
  }).catch(error => {
    console.log(error)
  })
}
const getPage = ({ commit }, slug) => {
  commit('PAGE_IS_LOADING_UPDATED', true)
  return wordpressService.getPage(slug).then((page) => {
    page = JSON.parse(page)
    page.POST_CONTENT = page.POST_CONTENT !== '' ? page.POST_CONTENT : '404'
    commit('PAGE_UPDATED', page)
    commit('PAGE_IS_LOADING_UPDATED', false)
    if (slug !== 'tekst-na-dole-w-projektach') {
      commit('SET_PAGE_TITLE', page.POST_TITLE)
    }
    commit('SET_PAGE_DESC', page.POST_EXCERPT)
  }).catch(error => {
    console.log(error)
  })
}
const getPost = ({ commit }, slug) => {
  commit('POST_IS_LOADING_UPDATED', true)
  return wordpressService.getPost(null, slug).then((post) => {
    post = JSON.parse(post)
    post.POST_CONTENT = post.POST_CONTENT !== '' ? post.POST_CONTENT : '404'
    commit('POST_UPDATED', post)
    commit('SET_PAGE_TITLE', post.POST_TITLE)
    commit('SET_PAGE_DESC', post.POST_EXCERPT)
    commit('POST_IS_LOADING_UPDATED', false)
  }).catch(error => {
    console.log(error)
  })
}
const getPosts = ({ commit }, getConditions) => {
  commit('POSTS_IS_LOADING_UPDATED', true)
  return wordpressService.getPosts(getConditions).then((page) => {
    commit('POSTS_UPDATED', page)
    commit('SET_PAGE_TITLE', 'Projekty')
    commit('SET_PAGE_DESC', 'Pracownia architektoniczna, której kluczowym profilem działalności jest kreowanie wnętrz komercyjnych. Tworzymy wyjątkowe projekty lokali handlowo-usługowych, sklepów, biur.')
    commit('POSTS_IS_LOADING_UPDATED', false)
  }).catch(error => {
    console.log(error)
  })
}

export {
  getPosts,
  getPost,
  getPage,
  getHomepage
}
